import React from 'react';
import { colorGray } from 'styles/layout/colors';
import PropTypes from 'prop-types';

const IconTrash = ({ color = colorGray, ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9005 3.67475V3.17475C15.9005 1.49995 14.5509 0.149246 12.875 0.149246H11.1504C9.4756 0.149246 8.1249 1.49885 8.1249 3.17475V3.67475H0.874899C0.474499 3.67475 0.150299 3.99995 0.150299 4.39935C0.150299 4.79975 0.475499 5.12395 0.874899 5.12395H2.4999L3.7499 20.1239C3.8749 21.6239 5.1503 22.7987 6.67465 22.7987H17.3749C18.8749 22.7987 20.1747 21.6239 20.2997 20.1239L21.5497 5.12395H23.1747C23.5751 5.12395 23.8993 4.79875 23.8993 4.39935C23.8748 4.02532 23.5497 3.67475 23.1502 3.67475H15.9005ZM9.59975 3.20015C9.59975 2.35055 10.2999 1.65035 11.1495 1.65035H12.8742C13.7238 1.65035 14.424 2.35055 14.424 3.20015V3.70015H9.5997L9.59975 3.20015ZM18.8 20.0254C18.7248 20.7754 18.0998 21.3506 17.3498 21.3506L6.65055 21.3496C5.87515 21.3496 5.27555 20.7744 5.20035 20.0244L3.95035 5.14942H20.0256L18.8 20.0254Z"
      fill={color}
    />
  </svg>
);

IconTrash.propTypes = {
  color: PropTypes.string,
};

export default IconTrash;
